/* eslint-disable react/prop-types */
import { Box, Button, Input, Tag, TagLabel, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import CustomModal from "./CustomModal/CustomModal";
import { IoAddCircle } from "react-icons/io5";
const RenderTag = ({ data, width, title, onAdd }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleOpenModal = () => {
    setInputValue("");
    setIsModalOpen(true);
  };

  const handleAddClick = () => {
    if (inputValue.trim() !== "") {
      onAdd(inputValue.trim());
      setInputValue("");
    }
    setIsModalOpen(false);
    setInputValue("");
  };

  return (
    <Box as="div" w={width} height="150px">
      <Text fontWeight="bold" mb={2} display="flex" alignItems="center" gap={4}>
        {title} :
        <IoAddCircle cursor="pointer" onClick={handleOpenModal} />
      </Text>

      <Box
        display="flex"
        flexWrap="wrap"
        gap={4}
        p={2}
        maxH={{ base: "170px", md: "180px" }}
        overflowY="auto"
      >
        {/* Render Tags */}
        {data?.map((zip, idx) => (
          <Tag key={idx} size="md" variant="primary">
            <TagLabel textAlign="center">{zip}</TagLabel>
          </Tag>
        ))}
      </Box>

      <CustomModal
        size="md"
        isCentered={true}
        title="Add new"
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        bodyContent={
          <>
            <Input
              placeholder="Add New"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />

            <Box mt={2} textAlign="right">
              <Button onClick={handleAddClick} variant="primaryButton">
                Save
              </Button>
            </Box>
          </>
        }
      />
    </Box>
  );
};

export default RenderTag;
